<template>
  <h1 aria-label="CAAMS Home Page: Tools and Information" style="color:darkblue; margin-top: 10px; margin-bottom: 20px; font-size: 24px; font-weight: bold;">CAAMS Home
    Page: Tools and Information
  </h1>

  <!-- ---------------------------------------------------------- -->
  <!-- -------------------- Overview ---------------------------- -->
  <!-- ---------------------------------------------------------- -->

  <div style="align-items: center; text-align: center;">

    <div style="align-items: center; text-align: center; margin: 0 auto; width: 70%;">

      <div class="childDiv divMarginBottom cardNew cardPadding">
        <div style="text-align: left;">

          <div class="libraryHeaderDiv">
            <span @click="handleToggleOverview" class="selectableHeader" aria-label="CAAMS Overview" tabindex="0">
              <span v-if="!showOverview" class="expandCollapseSymbol">+</span>
              <span v-if="showOverview" class="expandCollapseSymbolMinus">-</span>CAAMS Overview</span>
          </div>

          <div v-if="showOverview">

            <ul style="text-align: left;">
              <li>
                The Civilian Arming Authorization Management System (<span
                  style="font-weight: bold; font-size: 18px;">CAAMS</span>) manages the arming authorization process for
                DoD contractor personnel in CENTCOM. It is a
                continually evolving system which was updated in June 2023. Its workflow has been streamlined to get
                contractors approved and deployed more quickly.
              </li>
              <li>
                The CAAMS application is required for all contracts with armed civilians within the CENTCOM AOR.
              </li>
              <li>
                The CAAMS workflow has been streamlined to get contractors approved and deployed more quickly.
              </li>
              <li>
                For questions concerning the following, please submit a <a class="hyperlink" 
                  href="https://www.jccs.gov/HDPlus/Ext/App?Name=CAAMSNG" target="_blank"
                  title="Helpdesk & Feedback">Helpdesk Ticket</a> to receive support with the following:
                <ul>
                  <li>
                    Usage and Training
                  </li>
                  <li>
                    Technical Issues
                  </li>
                  <li>
                    Feedback
                  </li>
                </ul>
              </li>
              <li>
                The CAAMS team appreciates any and all feedback as we continue to expand to additional COCOMS. See the
                User Guides and Quick References section in the lower right of this page for additional information.
              </li>
            </ul>

          </div>

        </div>

      </div>

    </div>

  </div>

  <div class="container-main-div">

    <!-- ---------------------------------------------------------- -->
    <!-- -------------------- Column 1 ---------------------------- -->
    <!-- ---------------------------------------------------------- -->

    <div class="columnDivs">

      <!-- -------------------- Cell 1 ---------------------------- -->


      <!-- -------------------- Cell 2 ---------------------------- -->

      <div class="childDiv divMarginBottom cardNew cardPadding" :class="{ emphasisColor: dataExistsForRequiringAction }">

        <div class="libraryHeaderDiv">

          <span @click="handleToggleRequiringAction" class="selectableHeader" tabindex="0" @keydown.enter="handleToggleRequiringAction" aria-label="Items Requiring Action">
            <span v-if="!showRequiringAction" class="expandCollapseSymbol" aria-label="Expand this screen">+</span>
            <span v-if="showRequiringAction" class="expandCollapseSymbolMinus" aria-label="Collapse this screen">-</span>Items Requiring Action
          </span>

          <span class="selectableHeader">
            <span tabindex="0" aria-label="You have {{ numberOfItemsRequiringAction }} items" :class="{
              alertCountOfItemsFont: !extraAlertRequiringAttn,
              alertCountOfItemsAttentionFont: extraAlertRequiringAttn
            }">
              (You have {{ numberOfItemsRequiringAction }} items)
            </span>
          </span>

        </div>

        <div v-if="showRequiringAction" class="libraryTextDivNonFlex">

          <div class="libraryTextDivNonFlex tableInfoWdith">

            <div tabindex="0" style="display: block; margin-bottom: 10px;">
              The table below displays the items and allows you to perform actions by doing the following:
            </div>

            <div style="display: block;">
              <ul>
                <li>Click on the <b>Contract Numbers</b> to view contract details.</li>
                <!-- <li>Click on a <b>Hyperlinked Numbers</b> to view the required action item for a specific row/column
                  selection.</li> -->
              </ul>
            </div>

            <div style="display: block; margin-bottom: 30px;" tabindex="0">
              <b>Note:</b> An empty Table may indicate that there are no contracts assigned to your role.
            </div>

          </div>

          <table class="tableStyles" style="width: 98%">
            <tr>
              <th tabindex="0" class="headerFont headerCellBorder tableHeaderBordersPadding">Contract Number</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">QUAL Exp</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">QUAL Exp in 30 days</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">QUAL Exp in 120 days
              </th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">Deploy End Date Exp</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">Deploy End date Exp in
                30 days</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">Confirm Date over 30
                days</th>
            </tr>
            <tr v-for="(item, index) in itemsRequiringAction" :key="index">
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding" style="text-align: left;"><a herf="#"
                  class="text-primary" @click="TableAction('goToPersonsMaster', item.contractId, 0)">
                  {{
                    item.contractNumber
                  }}
                </a></td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">

                <a href="#" class="text-primary" @click="TableAction('goToPersonExpired', item.contractId, 0, 0)">{{
                  item.qualexp }}</a>
              </td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">
                <a href="#" class="text-primary" @click="TableAction('goToPersonExpired', item.contractId, 0, 30)">{{
                  item.quaL30 }}</a>
              </td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">
                <a href="#" class="text-primary" @click="TableAction('goToPersonExpired', item.contractId, 0, 120)">{{
                  item.quaL120 }}</a>
              </td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">
                <a href="#" class="text-primary" @click="TableAction('goToDeployDateExpired', item.contractId, 0, 0)">{{
                  item.depexp }}</a>
              </td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">
                <a href="#" class="text-primary" @click="TableAction('goToDeployDateExpired', item.contractId, 0, 30)">{{
                  item.depexP30 }}</a>
              </td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">
                <a href="#" class="text-primary" @click="TableAction('goToConfirmDateExpired', item.contractId, 0, 0)">{{
                  item.confirmexp }}</a>
              </td>
            </tr>
            <tr v-if="dataExistsForRequiringAction == false">
              <td tabindex="0" colspan="7"><span class="noRecordsCell">There are no records to display.</span></td>
            </tr>
          </table>

        </div>
      </div>

      <!-- -------------------- Cell 3 ---------------------------- -->

      <div class="childDiv cardNew cardPadding" :class="{ emphasisColor: dataExistsForUpdatedRecords }"
        style="margin-bottom: 50px;">

        <div class="libraryHeaderDiv">
          <span @click="handleToggleUpdatedRecords" @keydown.enter="handleToggleUpdatedRecords" tabindex="0" class="selectableHeader">
            <span v-if="!showUpdatedRecords" class="expandCollapseSymbol" aria-label="Click to expand this screen">+</span>
            <span v-if="showUpdatedRecords" class="expandCollapseSymbolMinus" aria-label="Click to collapse this screen">-</span>Recently Updated Records
          </span>

          <span class="selectableHeader">
            <span tabindex="0" aria-label="(You have {{ numberOfUpdatedRecords }} records)" :class="{
              alertCountOfItemsFont: !extraAlertUpdateEmphasis,
              alertCountOfItemsAttentionFont: extraAlertUpdateEmphasis
            }">
              (You have {{ numberOfUpdatedRecords }} records)
            </span>
          </span>

        </div>

        <div v-if="showUpdatedRecords" class="libraryTextDivNonFlex">

          <div tabindex="0" style="display: block; margin-bottom: 10px; margin-left: 10px;">
            In the last 7 days, the following records have been updated. The actions available are as follows:
          </div>

          <div style="display: block; margin-bottom: 10px;">
            <ul>
              <li tabindex="0">Click on the <b>Contract Numbers</b> to view contract details.</li>
              <!-- <li>Click on the <b>Hyperlinked Items</b> to view records requiring action for a specific row/column
                selection.</li>
              <ul>
                <li>
                  For example, to begin the QC process for an individual, click on the BV item to upload a BV letter to an
                  individual's record.
                </li>
              </ul> -->
            </ul>
          </div>

          <div tabindex="0" style="display: block; margin-bottom: 30px; margin-left: 10px;">
            <b>Note:</b> An empty Table may indicate that there are no contracts assigned to your role.
          </div>

          <table class="tableStyles" style="width: 98%;  margin-left: 10px;">
            <tr>
              <th tabindex="0" class="headerFont headerCellBorder tableHeaderBordersPadding">Contract Number</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">New</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">Hold</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">BV</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">QC</th>
              <th tabindex="0" class="headerFont headerCellBorder tdAlignmentCenter tableHeaderBordersPadding">Complete</th>
            </tr>
            <tr v-for="(item, index) in recentlyUpdatedRecords" :key="index">
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding" style="text-align: left;"><a herf="#"
                  class="text-primary" @click="TableAction('goToPersonsMaster', item.contractid, 0)">
                  {{
                    item.contractNumber
                  }}
                </a></td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding"> {{ item.new }}</td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">{{ item.hold }}</td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">{{ item.bv }}</td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">{{ item.qc }}</td>
              <td tabindex="0" class="tdStyle tdAlignmentCenter tableCellBordersPadding">{{ item.complete }}</td>
            </tr>
            <tr v-if="dataExistsForUpdatedRecords == false">
              <td tabindex="0" colspan="6"><span class="noRecordsCell">There are no records to display.</span></td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- ---------------------------------------------------------- -->
    <!-- -------------------- Column 2 ---------------------------- -->
    <!-- ---------------------------------------------------------- -->

    <div class="columnDivs">

      <!-- -------------------- Cell 4 ---------------------------- -->

      <div class="childDiv  divMarginBottom divMarginLeft  cardNew cardPadding" style="background-color: #faf0ff">

        <div class="libraryHeaderDiv">
          <span tabindex="0" @click="handleToggleDocumentLibrary" @keydown.enter="handleToggleDocumentLibrary" class="selectableHeader">
            <span v-if="!showDocumentLibrary" class="expandCollapseSymbol" aria-label="Click to expand this screen">+</span>
            <span v-if="showDocumentLibrary" class="expandCollapseSymbolMinus" aria-label="Click to collapse this screen">-</span>CAAMS Document Library</span>
        </div>

        <div v-if="showDocumentLibrary">

          <div tabindex="0" class="libraryTextDiv" style="margin-left: 20px;">
            PLEASE NOTE: some of the documents in the library below are multi-part PDF files; for best results, download
            the documents first, and then open the downloaded document.
          </div>

          <div tabindex="0" class="libraryTextDiv" style="margin-left: 20px;">
            Sample Documents
          </div>

          <ul style="text-align: left; margin-left: 20px;">
            <li class="libraryDocumentLinks">
              <a class="libraryDocumentLinks" tabindex="0" target="_blank" download
                :href="getFileURL('5. Rules of Force - Law of Armed Conflict Training Verified Mar 2018', 'pdf')"
                 aria-label="Click to download 05. Rules of Force - Law of Armed Conflict Training Verified Mar 2018"
                 title="Click to download 05. Rules of Force - Law of Armed Conflict Training Verified Mar 2018">
                05. Rules of Force - Law of Armed Conflict Training Verified Mar 2018
              </a>

            </li>
            <li class="libraryDocumentLinks">
              <a class="libraryDocumentLinks" tabindex="0" target="_blank" download
                 aria-label="Click to download 06. Acknowledgement of Training Form (Contractor) Verified Mar 2018"
                 title="Click to download 06. Acknowledgement of Training Form (Contractor) Verified Mar 2018"  
                :href="getFileURL('6. Acknowledgement of Training Form (Contractor) Verified Mar 2018', 'pdf')">
                06. Acknowledgement of Training Form (Contractor) Verified Mar 2018
              </a>

            </li>
            <li class="libraryDocumentLinks">
              <a class="libraryDocumentLinks" tabindex="0" target="_blank" download 
                 aria-label="Click to download 07. Qualification to Possess Firearms or Ammunition (DD Form 2760) Verified Mar 2018"
                 title="Click to download 07. Qualification to Possess Firearms or Ammunition (DD Form 2760) Verified Mar 2018"  
                :href="getFileURL('7. Qualification to Possess Firearms or Ammunition (DD Form 2760) Verified Mar 2018', 'pdf')">
                07. Qualification to Possess Firearms or Ammunition (DD Form 2760) Verified Mar 2018
              </a>

            </li>
            <li class="libraryDocumentLinks">
              <a class="libraryDocumentLinks" tabindex="0" target="_blank" download 
                 aria-label="Click to download 08. SPOT LOA Sample Verified Mar 2018"
                 title="Click to download 08. SPOT LOA Sample Verified Mar 2018"  
                 :href="getFileURL('8. SPOT LOA Sample Verified Mar 2018', 'pdf')">
                08. SPOT LOA Sample Verified Mar 2018
              </a>

            </li>
            <li class="libraryDocumentLinks">
              <a class="libraryDocumentLinks" tabindex="0" target="_blank" download 
                 aria-label="Click to download 10. Background Check MEMO Template Verified Mar 2018"
                 title="Click to download 10. Background Check MEMO Template Verified Mar 2018"  
                :href="getFileURL('10. Background Check MEMO Template Verified Mar 2018', 'pdf')">
                10. Background Check MEMO Template Verified Mar 2018
              </a>

            </li>
            <li class="libraryDocumentLinks">
              <a class="libraryDocumentLinks" tabindex="0" target="_blank" download 
                 aria-label="Click to download Serious Incident Report (SIR) - Template" 
                 title="Click to download Serious Incident Report (SIR) - Template"
                 :href="getFileURL('Serious Incident Report (SIR) - Template', 'xlsx')">
                Serious Incident Report (SIR) - Template
              </a>
            </li>
          </ul>

          <div tabindex="0" class="libraryTextDiv" style="margin-left: 20px;">
            Previous DoD supporting policy
          </div>

          <ul style="text-align: left; margin-left: 20px;">
            <li class="">
              <!-- <a class="libraryDocumentLinks" tabindex="0" target="_blank" download 
                 aria-label="Click to download USCENTCOM OPORD 05-03, Appendix 8 to Annex C"
                 title="Click to download USCENTCOM OPORD 05-03, Appendix 8 to Annex C"   
                 :href="getFileURL('USCENTCOM OPORD 05-03, Appendix 8 to Annex C', 'pdf')">
                USCENTCOM OPORD 05-03, Appendix 8 to Annex C
              </a> -->
              USCENTCOM OPORD 05-03, Appendix 8 to Annex C
            </li>
            <li class="">
              <!-- <a class="hyperlink" tabindex="0" target="_blank" download 
                 aria-label="Click to download DoDI 3020.50 - Private Security Contractors"
                 title="Click to download DoDI 3020.50 - Private Security Contractors"  
                 :href="getFileURL('DoDI 3020.50 - Private Security Contractors', 'pdf')">
                DoDI 3020.50 - Private Security Contractors
              </a> -->
              DoDI 3020.50 - Private Security Contractors
            </li>
            <li class="">
              <!-- <a class="libraryDocumentLinks" tabindex="0" target="_blank" download 
                 aria-label="Click to download DoDD 5210.56 - Arming and the Use of Force"
                 title="Click to download DoDD 5210.56 - Arming and the Use of Force"  
                 :href="getFileURL('DoDD 5210.56 - Arming and the Use of Force', 'pdf')">
                DoDD 5210.56 - Arming and the Use of Force
              </a> -->
              DoDD 5210.56 - Arming and the Use of Force
            </li>
            <li class="">
              <!-- <a class="libraryDocumentLinks" tabindex="0" target="_blank" download 
                 aria-label="Click to download DoDI 3020.41 Operational Contract Support"
                 title="Click to download DoDI 3020.41 Operational Contract Support"  
                 :href="getFileURL('DoDI 3020.41 - Operational Contract Support', 'pdf')">
                DoDI 3020.41 Operational Contract Support
              </a> -->
              DoDI 3020.41 Operational Contract Support
            </li>
            <!-- <li>
              <a target="_blank" download :href="getFileURL('b7729148-4f3d-404b-94bf-5ed347307b2e', 'pdf')">

              </a>
              COR - New Package Approval Process Walk Through - for COR
            </li>
            <li>
              <a target="_blank" download :href="getFileURL('b7729148-4f3d-404b-94bf-5ed347307b2e', 'pdf')">

              </a>
              COR - Renewal Package Approval Process Walk Through - for COR
            </li> 
            <li>
              <a target="_blank" download :href="getFileURL('b7729148-4f3d-404b-94bf-5ed347307b2e', 'pdf')">

              </a>
              DoD Civilian Arming Guidance
            </li>-->
            
            <!-- <li>
              <a target="_blank" download :href="getFileURL('b7729148-4f3d-404b-94bf-5ed347307b2e', 'pdf')">

              </a>
              ACOD Overview Brief -COR
            </li> -->
          </ul>

        </div>

      </div>

      <!-- -------------------- CELL 5 ---------------------------- -->

      <div class="childDiv divMarginLeft cardNew cardPadding">

        <div class="libraryHeaderDiv">
          <span tabindex="0" @click="handleToggleQuickReference" @keydown.enter="handleToggleQuickReference" class="selectableHeader">
            <span v-if="!showQuickReference" class="expandCollapseSymbol" aria-label="Click to expand this screen">+</span>
            <span v-if="showQuickReference" class="expandCollapseSymbolMinus" aria-label="Click to collapse this screen">-</span>CAAMS Quick Reference & User
            Guides</span>
        </div>

        <div v-if="showQuickReference">

          <div tabindex="0" class="libraryTextDivNonFlex" style="margin-left: 20px;">
            There are two <b>Quick Referrences</b> and two <b>User Guides</b>. Each set is role specific.
          </div>

          <ul style="text-align: left; margin-left: 20px;">

              <li tabindex="0">
                  <b>Vendor Role</b>
                  <ul>
                      <li>
                          <a tabindex="0" class="libraryDocumentLinks" target="_blank" download
                             aria-label="Click to download the CAAMS Vendor User Guide - Designed to help Vendors maximize their efficiency when using CAAMS"
                             title="CLick to download the CAAMS Vendor User Guide - Designed to help Vendors maximize their efficiency when using CAAMS"
                             :href="getFileURL('CAAMSNG Vendor User Guide', 'pdf')">
                              CAAMS Vendor User
                              Guide
                          </a> - Designed to help Vendors maximize their efficiency when using CAAMS.
                      </li>

                      <li>
                          <a tabindex="0" class="libraryDocumentLinks" target="_blank" download
                             aria-label="Click to download the CAAMS Vendor Quick Reference - Provides an overview/reference for the major responsibilites of CAAMS Vendor users"
                             title="Click to download the CAAMS Vendor Quick Reference - Provides an overview/reference for the major responsibilites of CAAMS Vendor users "
                             :href="getFileURL('Quick_Reference_Guide_Vendor', 'pdf')">
                              CAAMS Vendor Quick
                              Reference
                          </a> - Provides an overview/reference for the major responsibilites of CAAMS Vendor users.
                      </li>

                  </ul>
              </li>
              <li tabindex="0">
                  <b>KO/COR Role</b>
                  <ul>

                      <li>
                          <a tabindex="0" class="libraryDocumentLinks" target="_blank" download
                             aria-label="Click to download the CAAMS KO/COR User Guide - Details the responsibilities and workflow processes managed with the KO/COR role"
                             title="Click to download the CAAMS KO/COR User Guide - Details the responsibilities and workflow processes managed with the KO/COR role"
                             :href="getFileURL('CAAMSNG KOCOR User Guide', 'pdf')">CAAMS KO/COR User Guide</a> -
                          Details the responsibilities and workflow processes managed with the KO/COR role.
                      </li>

                      <li>
                          <a tabindex="0" class="libraryDocumentLinks" target="_blank" download
                             aria-label="Click to dowload the CAAMS KO/COR Quick Reference - Provides an over an overview/reference for the major responsibilities of CAAMS KO/COR users"
                             title="Click to dowload the CAAMS KO/COR Quick Reference - Provides an over an overview/reference for the major responsibilities of CAAMS KO/COR users"
                             :href="getFileURL('Quick_Reference_Guide_KOCOR', 'pdf')">
                              CAAMS KO/COR Quick Reference
                          </a> - Provides an over an overview/reference for the major responsibilities
                          of CAAMS KO/COR users.
                      </li>
                  </ul>
              </li>
            <li style="margin-top: 15px;">
              <router-link tabindex="0" :to="{ name: 'homeFAQ' }"><span class="libraryDocumentLinks">FAQ</span></router-link> - CAAMS Frequently Asked Questions
            </li>

            <li>
              <router-link tabindex="0" :to="{ name: 'homeAbout' }"><span class="libraryDocumentLinks">About</span></router-link> -
              Background and historical information about the creation and usage of CAAMS.
            </li>

          </ul>

        </div>

      </div>

      <!-- -------------------- CELL END ---------------------------- -->

    </div>

  </div>
</template>
  
<script>
import axios from "axios";
import { store } from "../store/store.js";

export default {
  data() {
    return {
      store,
      fileServer: 'https://www.jccs.gov/caamsng/files/',
      itemsRequiringAction: null,
      recentlyUpdatedRecords: null,
      dataExistsForRequiringAction: true,
      dataExistsForUpdatedRecords: true,

      showOverview: true,

      showRequiringAction: false,
      showRequiringActionInstructions: false,

      showUpdatedRecords: false,
      showDocumentLibrary: false,
      showQuickReference: false,

      numberOfItemsRequiringAction: 0,
      numberOfUpdatedRecords: 0,

      extraAlertRequiringAttn: false,
      extraAlertUpdateEmphasis: false,

      enableItemsRequiringAction: false,
      enableUpdatedRecords: false,

    };
  },

  props: {},
  emits: [],
  watch: {},
  created() {
    this.getItemsRequiringAction();
    this.getRecentlyUpdatedRecords();
  },
  components: {},
  computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null ? store.authenticatedUser.userProfileId : store.tempUserProfileId;
    },
  },
  methods: {

    handleToggleOverview() {
      this.$data.showOverview = !this.$data.showOverview;
    },

    handleToggleRequiringAction() {
      this.$data.showRequiringAction = !this.$data.showRequiringAction;
    },

    handleToggleUpdatedRecords() {
      this.$data.showUpdatedRecords = !this.$data.showUpdatedRecords;
    },

    handleToggleDocumentLibrary() {
      this.$data.showDocumentLibrary = !this.$data.showDocumentLibrary;
    },

    handleToggleQuickReference() {
      this.$data.showQuickReference = !this.$data.showQuickReference;
    },

    getItemsRequiringAction() {
      axios
        .get(store.webAPIUrl + "UserProfile/SelwExpirationsUserId/" + this.UserProfileId)
        .then((response) => response.data)
        .then((data) => {
          this.$data.itemsRequiringAction = data;
          console.log('this.$data.itemsRequiringAction = ', this.$data.itemsRequiringAction);
          // this.logItemsRequiringAction();
          let size = 0;
          this.$data.itemsRequiringAction.forEach(() => {
            size++;
          });
          this.$data.numberOfItemsRequiringAction = size;
          if (size > 0) {
            this.$data.dataExistsForRequiringAction = true;
            this.$data.extraAlertRequiringAttn = true;
            this.$data.showRequiringAction = true;
          } else {
            this.$data.extraAlertRequiringAttn = false;
          }
        });
    },

    getRecentlyUpdatedRecords() {
      axios
        .get(store.webAPIUrl + "UserProfile/SelwStatusChangeUserId/" + this.UserProfileId)
        .then((response) => response.data)
        .then((data) => {
          this.$data.recentlyUpdatedRecords = data;
          // console.log('this.$data.recentlyUpdatedRecords= ', this.$data.recentlyUpdatedRecords);
          // this.logIRecentlyUpdatedRecords();
          let size = 0;
          this.$data.recentlyUpdatedRecords.forEach(() => {
            size++;
          });
          this.$data.numberOfUpdatedRecords = size;
          if (size > 0) {
            this.$data.dataExistsForUpdatedRecords = true;
            this.$data.extraAlertUpdateEmphasis = true;
            this.$data.showUpdatedRecords = true;
          } else {
            this.$data.extraAlertUpdateEmphasis = false;
          }
        });
    },

    getFileURL(docGUID, docMime) {
      // console.log('#1');
      //let fileName = slotArgs.itemArg['documentGuid'] + slotArgs.itemArg['documentMimeType'];
      let fileName = docGUID + '.' + docMime;
      let url = this.$data.fileServer + fileName;
      // console.log('DocCmp: getFileURL(): url = ', url);
      return url;
    },

    logItemsRequiringAction() {
      this.$data.itemsRequiringAction.forEach((item) => {
        console.log('item = ', item);
        console.log('item.contractId = ', item.contractId);
      });
    },

    logIRecentlyUpdatedRecords() {
      this.$data.recentlyUpdatedRecords.forEach((item) => {
        console.log('item = ', item);
        console.log('item.contractId = ', item.contractId);
      });
    },

    TableAction(actionNameIdentifier, _contractId, _companyId, _expirationTime) {
      //console.log(_companyId)
      store.tempContractId = _contractId;
      store.tempCompanyId = _companyId;

      switch (actionNameIdentifier) {
        case 'goToPersonsNew':
          this.$router.push({ name: 'PersonsByContractNew', params: { contractId: _contractId } })
          break;
        case 'bv':
          alert('Open Biometric page list for contract ' + _contractId);
          break;
        case 'qc':
          this.$router.push({ name: 'PersonsByContractQC', params: { contractId: _contractId } })
          break;
        case 'complete':
          this.$router.push({ name: 'PersonsByContractComplete', params: { contractId: _contractId } })
          break;
        case 'goToPersonsHold':
          this.$router.push({ name: 'PersonsByContractHold', params: { contractId: _contractId } })
          break;
        case 'goToPersonsMaster':
          console.log("contractid = " + _contractId);
          this.$router.push({ name: 'PersonsByContractMaster', params: { contractId: _contractId } })
          break;
        case 'goToPersonExpired':
          this.$router.push({ name: 'PersonsByQualExpiration', params: { contractId: _contractId }, query: { expireTime: _expirationTime, mode: "qual" } });
          break;
        case 'goToDeployDateExpired':
          this.$router.push({ name: 'PersonsByQualExpiration', params: { contractId: _contractId }, query: { expireTime: _expirationTime, mode: "deploy" } });
          break;
        case 'goToConfirmDateExpired':
          this.$router.push({ name: 'PersonsByQualExpiration', params: { contractId: _contractId }, query: { expireTime: _expirationTime, mode: "confirm" } });
          break;
        default:
          alert('Please select a contract and column to proceed');
      }
    }



  },

};
</script>
  
<style scoped>
/* ----------------------- header selectablity ------------------------ */

.selectableHeader {
  cursor: pointer;
  font-weight: bold;
}

.expandCollapseSymbol {
  color: darkred;
  margin-right: 10px;
  font-size: 18px;
}

.expandCollapseSymbolMinus {
  color: darkred;
  margin-right: 10px;
  font-size: 24px;
}

.alertCountOfItemsFont {
  font-size: 14px;
  margin-left: 20px;
  font-weight: normal;
}

.alertCountOfItemsAttentionFont {
  font-size: 16px;
  margin-left: 16px;
  color: darkred;
}

/* ----------------------- Containers ------------------------ */

.emphasisColor {
  background-color: #fff5e6;
}

.container-main-div {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 60% 38%;
}

.columnDivs {
  display: flex;
  flex-direction: column;
}

/* ----------------------- Tables ------------------------ */

.tableHeaderBordersPadding {
  border-right: 1px solid lightgray;
  padding: 3px;
}

.tableCellBordersPadding {
  border-bottom: 1px solid lightgray;
  border-right: 1px solid lightgray;
  padding: 5px;
}

.tableInfoWdith {
  width: 98%;
}

    .noRecordsCell {
        color: #DC143C;
        font-weight: bold;
        vertical-align: middle;
    }

.tableStyles {
  border-collapse: collapse;
  padding: 3px;
  width: 100%;
}

.headerFont {
  font-size: 14px;
  color: black;
}

.tdAlignmentCenter {
  text-align: center;
}

.headerCellBorder {
  border-bottom: 3px solid #e6e6e6;
  border-collapse: collapse;
}

.tdStyle {
  /* color: blue;
  text-decoration: underline;
  cursor: pointer; */
  background-color: #f8f8f8;
}

/* ----------------------- library section ------------------------ */
    .hyperlink {
        color: #0000FF;
        cursor: pointer;
        /*background-color: #f8f8f8;*/
        text-decoration:underline;
    }

    .libraryDocumentLinks {
        color: #0000FF;
        text-decoration: underline;
        cursor: pointer;
    }

.libraryTextDiv {
  text-align: left;
  align-items: left;
  display: flex;
  margin-bottom: 15px;
}

.libraryHeaderDiv {
  text-align: left;
  align-items: left;
  display: flex;
  font-size: 18px;
  margin-bottom: 15px;
  align-items: center;
  padding: 0px;
}

.libraryTextDivNonFlex {
  text-align: left;
  align-items: left;
  margin-bottom: 15px;
  margin-left: 10px;
}

/* ----------------------- margins ------------------------ */

.divMarginBottom {
  margin-bottom: 20px;
}

.divMarginLeft {
  margin-left: 20px;
}

/* ----------------- SHADOW BOX ------------------------- */

.cardNew {
  width: 100%;
  border: 1px solid black;
}

/* .cardNew {
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 30px -20px, rgba(0, 0, 0, 0.3) 0px 30px 15px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  width: 100%;
  border: 1px solid lightgrey;
} */

.cardPadding {
  padding-left: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
}</style>
  